import { render, staticRenderFns } from "./procurement.vue?vue&type=template&id=60870a8f&scoped=true"
import script from "./procurement.vue?vue&type=script&lang=js"
export * from "./procurement.vue?vue&type=script&lang=js"
import style0 from "./procurement.vue?vue&type=style&index=0&id=60870a8f&prod&lang=scss&scoped=true"
import style1 from "./procurement.vue?vue&type=style&index=1&id=60870a8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60870a8f",
  null
  
)

export default component.exports